import { PDFRelatorioMovimentacaoBancariaResponse } from "features/relatorios/typings";
import { PDFRelatorioBase } from "components/PDF";
import useRelatorioDespesaPdfColumns from "../hooks/useRelatorioDespesaPdfColumns";
import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import moment from "moment";

function PDFRelatorioMovimentacaoFinanceira(
  props: PDFRelatorioMovimentacaoBancariaResponse & { dataSaldo: string }
) {
  const columns = useRelatorioDespesaPdfColumns();

  return (
    <PDFRelatorioBase
      title="Relatório de movimentações financeiras"
      relatorioData={props as PDFRelatorioMovimentacaoBancariaResponse}
      columns={columns}
      pdfHeaderProps={{
        cards: [
          {
            title: "Resultado",
            value: `R$ ${formatCurrency(props.totais.resultado)}`,
            alignItems: "flex-end",
          },
          {
            title: `Saldo em ${moment(props.dataSaldo).format("DD/MM/YYYY")}`,
            value: `R$ ${formatCurrency(props.totais.saldoDataFim)}`,
            alignItems: "flex-end",
          },
        ],
      }}
    />
  );
}

export default PDFRelatorioMovimentacaoFinanceira;
